module.exports = __webpack_public_path__ + "img/3right-5fa68a91.png";